// Start of Clerk.io E-commerce Personalisation tool - www.clerk.io

let clerkKey = document.body.dataset.clerkKey;

if (clerkKey && clerkKey !== "NONE") {
    (function (w, d) {
        let e = d.createElement('script'); e.type = 'text/javascript'; e.async = true;
        e.src = 'https://cdn.clerk.io/clerk.js';
        let s = d.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);
        w.__clerk_q = w.__clerk_q || []; w.Clerk = w.Clerk || function () { w.__clerk_q.push(arguments) };
    })(window, document);

    Clerk('config', {
        key: clerkKey,
        formatters: {
            currency_selector: function (price_list) {
                const currency = document.body.dataset.currency;
                const destinationSalesTaxRate = document.body.dataset.destinationSalesTaxRate;

                // Parse the string into a dictionary of [currencyCode_SalesTaxRate] and formatted prices.
                let price_groups_obj = JSON.parse(price_list);
                let formattedPrice = price_groups_obj[currency + "_" + destinationSalesTaxRate];

                return formattedPrice;
            },
            fix_url: function (url) {
                const domain = window.location.origin;
                const localeUrlPrefix = document.body.dataset.localeUrlPrefix;
                const path_name = new URL(url).pathname;

                return `${domain}${localeUrlPrefix}${path_name}`;
            }
        }
    });
}

// End of Clerk.io E-commerce Personalisation tool - www.clerk.io
